module.exports = __webpack_public_path__ + "static/media/send_voting_reminder.58cbd356.svg";